
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'

import { EnumOrderButtonType } from '@xt/client/enums'

import type { OrderItem } from '@xt/client/entities/my-v2/types.d'

@Observer
@Component({
  components: {}
})
export default class OrderButton extends Vue {
  @Prop({ required: true }) type: EnumOrderButtonType

  @Prop({ required: true }) orderItem: OrderItem

  get EnumOrderButtonType() {
    return EnumOrderButtonType
  }

  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
